import { FormControl, FormHelperText, Input, InputLabel, Link, MenuItem, Select } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import { IndustryTypes } from "models/IndustryTypes";
import { Nullable } from "models/Nullable";
import { Paths } from "Paths";
import { MenuProps } from "screens/MyOrgScreen";

type Props = {
    industryType: Nullable<IndustryTypes.IndustryType>
    setIndustryType: (industryType: IndustryTypes.IndustryType) => void
}

export function IndustryTypeSelect({ industryType, setIndustryType }: Props) {
    return (
        <FormControl fullWidth>
            <InputLabel htmlFor="industry-type-native-simple">Bransje</InputLabel>
            <Select
                labelId="industry-type-mutiple-chip-label"
                id="industry-type-mutiple-chip"
                input={<Input id="select-multiple-chip" />}
                MenuProps={MenuProps}
                value={industryType || ""}
                onChange={(e) => setIndustryType(e.target.value as IndustryTypes.IndustryType)}
                fullWidth
                required
                error={!industryType}
                variant="outlined"
                placeholder="Velg en Bransje"
                inputProps={{
                    name: 'bransje',
                    id: 'industry-type-native-simple',
                }}
            >
                <MenuItem key="EMPTY" value="">Ingen</MenuItem>
                {IndustryTypes.FlatList.map((description) => (
                    <MenuItem key={description.id} value={description.id}>
                        {description.name}
                    </MenuItem>
                ))}
                <MenuItem value="other">
                    <Link component={RouterLink} to={Paths.OWN_HELP_MESSAGES}>Foreslå ny bransje</Link>
                </MenuItem>
            </Select>
            {<FormHelperText error={!industryType}>{industryType ? 'NB! Dette kan ikke endres' : 'Velg en Bransje'}</FormHelperText>}
        </FormControl>
    )
}